import React, { useEffect, useState } from "react";
import { Button, DatePicker, Divider, Input, message, Modal, Select, Tabs, Row, Col, Tooltip, Image, Alert } from "antd";
import AuthService from "../auth/AuthService";
import config from "../config";
import { BgColorsOutlined, DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import qs from "query-string";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { HelperReminderTasks } from "../common/Constants";
import { showMessage } from "../Utils/message";

const Auth = new AuthService();

const EditHelperReminderModal = ({ isModalOpen, setIsModalOpen, allHelpers, selectedRecord, setSelectedRecord, searchFunction }) => {
  const { Option } = Select;
  const { TextArea } = Input;
  var layoutDispatch = useLoadingDispatch();

  const [selectedHelper, setSelectedHelper] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [taskCompleted, setTaskCompleted] = React.useState(null);
  const [record, setRecord] = React.useState(selectedRecord);
  const [notes, setNotes] = React.useState("");

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  console.log('selectedRecord', selectedRecord);

  useEffect(()=>{
    if(selectedRecord) {
      setCurrentItemFiles(selectedRecord?.files ? JSON.parse(selectedRecord?.files) : [])
      setNotes(selectedRecord?.notes || '')
      setSelectedHelper(selectedRecord?.warehouse_helper_id);
      setTaskCompleted(selectedRecord?.status)
      setSelectedTask(selectedRecord?.type)

      setDueDate(selectedRecord?.due_date ? dayjs(selectedRecord?.due_date, 'YYYY-MM-DD') : null)
    }
  },[selectedRecord])

  console.log(selectedHelper, allHelpers);
  


  const handleCancel = () => {
    setIsModalOpen(false);
    resetState()
  };

  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
            { value: selectedHelper, message: 'Please select helper' },
            { value: selectedTask, message: 'Please select service task' },
            { value: dueDate, message: 'Please select due date' },
          ];
    
          for (let { value, message: errorMessage } of validations) {
            if (isEmptyOrUndefined(value)) {
              showMessage('error', errorMessage);
              return;
            }
          }
    showLoading(layoutDispatch);
    const dataToSend = {
      warehouse_helper_id : selectedHelper, 
      due_date: dueDate ? dayjs(dueDate).format("YYYY-MM-DD") : null,
      type:selectedTask,
      notes: notes,
      files: currentItemFiles,
      // status: taskCompleted,
      id: selectedRecord?.id
    }
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/reminder-warehouse-helper", {
        method: "PUT",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {
        console.log(res);
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, selectedRecord?.id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);

        showMessage("success", res?.message);
        setIsModalOpen(false);
        searchFunction()
      } else {
        showMessage("error", res?.message);
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: config.wms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/warehouse-reminders-helper/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const resetState = () => {
    setNotes('');
    setFiles([]);
    setCurrentItemFiles([]);
    setDeletedFiles([]);
    setSelectedHelper(null);
    setSelectedTask(null);
    setDueDate(null)
    setTaskCompleted(null)
    setSelectedRecord("")
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };


  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        title={"Edit Helper Reminder "}
        footer={[
          <>
                <Button
                  onClick={handleCancel}
                >
                  {"Cancel"}
                </Button>
                <Button
                  type="primary"
                  onClick={handleOk}
                >
                  {"Update"}
                </Button>
          </>,
        ]}
      >
        <>
        <Divider />
        <>
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Helper<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedHelper}
              placeholder="Helper"
              onChange={(value) => {
                setSelectedHelper(value);
              }}
            >
              {allHelpers?.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.first_name}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Task<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedTask}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedTask(value);
              }}
            >
              {HelperReminderTasks.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Due Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={"DD-MM-YYYY"}
              value={dueDate}
              onChange={(date) => {
                setDueDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              disabledDate={disabledDate}
            />
            </Col>
            </Row>
          <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} />
            </Col>
          </Row>
        </>
        
        <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            // onChange={(e) => {
            //   handleSubmitImage(e);
            // }}
            onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            showMessage("error", "A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const lastHyphenIndex = item.lastIndexOf("-");
                        const dotBeforeExtensionIndex = item.lastIndexOf(".");
                        const newFileName =
                          item.slice(0, lastHyphenIndex) +
                          item.slice(dotBeforeExtensionIndex);
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${config.wms_uploads_cdn}/${config.env}/warehouse-reminders-helper/${selectedRecord?.id}/${item}`}
                              target="_blank"
                            >
                              {newFileName}
                            </a>
                          </li>
                        );
                      })}
                </ul>
      
        <Divider />
      {files?.length > 0 && <h4>Files:</h4>}
      <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>
            
          </>
        </>
          
      </Modal>
    </>
  );
};

export default EditHelperReminderModal;
